export const LABEL_MAP: Record<string, string> = {
  // Basic contact info
  avatar: 'Avatar',
  firstName: 'First Name',
  lastName: 'Last Name',
  nickname: 'Nickname',
  email: 'Email',
  cellPhone: 'Cell Phone',
  homePhone: 'Home Phone',
  fax: 'Fax',

  // Address fields
  street1: 'Street Address',
  street2: 'Street Address 2',
  city: 'City',
  state: 'State',
  county: 'County',
  zip: 'ZIP Code',

  // Professional info
  licenseNumber: 'License Number',
  licenseState: 'License State',
  title: 'Title',
  role: 'Role',
  type: 'Contact Type',

  // Company info
  companyName: 'Company Name',
  officeNumber: 'Office Number',
  teamName: 'Team Name',
  teamAlias: 'Team Alias',
  teamId: 'Team ID',

  // MLS info
  mlsId: 'MLS ID',
  primaryMls: 'Primary MLS',

  // Transaction info
  commission: 'Commission',
  sellingCommission: 'Selling Commission',
  confirmationNumber: 'Confirmation Number',
  escrowNumber: 'Escrow Number',
  titleNumber: 'Title Number',
  listingPeriod: 'Listing Period',

  // Status fields
  entityType: 'Entity Type',
  ownershipStatus: 'Ownership Status',
  isSelfRepresented: 'Self Represented',
  isSuccessor: 'Is Successor',
  contactSource: 'Contact Source',
  jurisdiction: 'Jurisdiction',

  // System fields
  id: 'ID',
  externalId: 'External ID',
  interactionId: 'Interaction ID',
  userId: 'User ID',
  createdBy: 'Created By',
  updatedBy: 'Updated By',
  order: 'Order',

  // External integrations
  followUpBossContactId: 'FollowUpBoss Contact ID',
  googleContactId: 'Google Contact ID',
  teamBusinessLicenseEntityNumber: 'Team Business License Entity Number',

  // Nested broker fields
  'broker.cellPhone': 'Broker Cell Phone',
  'broker.email': 'Broker Email',
  'broker.firstName': 'Broker First Name',
  'broker.lastName': 'Broker Last Name',
  'broker.licenseNumber': 'Broker License Number',

  // Nested brokerage fields
  'brokerage.cellPhone': 'Brokerage Cell Phone',
  'brokerage.city': 'Brokerage City',
  'brokerage.companyName': 'Brokerage Company Name',
  'brokerage.county': 'Brokerage County',
  'brokerage.email': 'Brokerage Email',
  'brokerage.fax': 'Brokerage Fax',
  'brokerage.jurisdiction': 'Brokerage Jurisdiction',
  'brokerage.licenseNumber': 'Brokerage License Number',
  'brokerage.mlsCode': 'Brokerage MLS Code',
  'brokerage.mlsId': 'Brokerage MLS ID',
  'brokerage.officeEmail': 'Brokerage Office Email',
  'brokerage.phone': 'Brokerage Phone',
  'brokerage.state': 'Brokerage State',
  'brokerage.street1': 'Brokerage Street Address',
  'brokerage.street2': 'Brokerage Street Address 2',
  'brokerage.taxId': 'Brokerage Tax ID',
  'brokerage.zip': 'Brokerage ZIP Code',

  // Nested entity fields
  'entity.entityName': 'Entity Name',
  'entity.title': 'Entity Title',
  'entity.titleOther': 'Entity Title (Other)',

  // Nested office manager fields
  'officeManager.cellPhone': 'Office Manager Cell Phone',
  'officeManager.email': 'Office Manager Email',
  'officeManager.firstName': 'Office Manager First Name',
  'officeManager.lastName': 'Office Manager Last Name',
  'officeManager.licenseNumber': 'Office Manager License Number',

  // Nested power of attorney fields
  'powerOfAttorney.email': 'Power of Attorney Email',
  'powerOfAttorney.firstName': 'Power of Attorney First Name',
  'powerOfAttorney.lastName': 'Power of Attorney Last Name',

  // Nested probate fields
  'probate.estateName': 'Estate Name',
  'probate.title': 'Probate Title',
  'probate.titleOther': 'Probate Title (Other)',

  // Nested referral client types
  'referralClientTypes.referralBuyer': 'Referral Buyer',
  'referralClientTypes.referralLandlord': 'Referral Landlord',
  'referralClientTypes.referralSeller': 'Referral Seller',
  'referralClientTypes.referralTenant': 'Referral Tenant',

  // Nested supervising broker fields
  'supervisingBroker.cellPhone': 'Supervising Broker Cell Phone',
  'supervisingBroker.email': 'Supervising Broker Email',
  'supervisingBroker.firstName': 'Supervising Broker First Name',
  'supervisingBroker.lastName': 'Supervising Broker Last Name',
  'supervisingBroker.licenseNumber': 'Supervising Broker License Number',

  // Nested trust fields
  'trust.title': 'Trust Title',
  'trust.titleOther': 'Trust Title (Other)',
  'trust.trustName': 'Trust Name',
};

export const CONTACT_TYPE_LABEL_MAP: Record<string, string> = {
  agent: 'Agent',
  appraiser: 'Appraiser',
  attorney: 'Attorney',
  client: 'Buyer',
  closingAttorney: 'Closing Attorney',
  counterpartyAgent: 'Counterparty Agent',
  counterpartyAttorney: 'Counterparty Attorney',
  counterpartyClient: 'Counterparty Client',
  counterpartyTransactionCoordinator: 'Counterparty Transaction Coordinator',
  escrowOfficer: 'Escrow Officer',
  homeWarranty: 'Home Warranty',
  lender: 'Lender',
  other: 'Contact',
  propertyManagingAgent: 'Property Managing Agent',
  titleOfficer: 'Title Officer',
  transactionCoordinator: 'Transaction Coordinator',
};
